import { render, staticRenderFns } from "./StudioAdminIndex.vue?vue&type=template&id=6a43b0e8&scoped=true"
import script from "./StudioAdminIndex.vue?vue&type=script&lang=js"
export * from "./StudioAdminIndex.vue?vue&type=script&lang=js"
import style0 from "./StudioAdminIndex.vue?vue&type=style&index=0&id=6a43b0e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a43b0e8",
  null
  
)

export default component.exports